import { render, staticRenderFns } from "./LinkedProjectDetail.vue?vue&type=template&id=51ccd756"
import script from "./LinkedProjectDetail.vue?vue&type=script&lang=js"
export * from "./LinkedProjectDetail.vue?vue&type=script&lang=js"
import style0 from "./LinkedProjectDetail.vue?vue&type=style&index=0&id=51ccd756&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports